import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

/**
 * Formatea fecha en formato corto
 */
const formatDate = (fecha) => {
    if (!fecha) return '';
    const date = new Date(fecha);
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return date.toLocaleDateString('es-MX', options).toUpperCase();
};

/**
 * Componente para mostrar pólizas asignadas a un producto
 */
const PolizasAsignadas = ({ objPolizas, product }) => {
    return (
        <>
            {objPolizas.map((objPoliza, index) => {
                const keyPoliza = objPoliza.idPoliza > 0
                    ? `pol-${product.idOrdenDetalle}-${objPoliza.idPoliza}`
                    : `pol-empty-${product.idOrdenDetalle}-${index}`;

                // Si tiene póliza asignada
                if (objPoliza.idPoliza > 0) {
                    return (
                        <Col
                            key={keyPoliza}
                            xs={12}
                            md={12}
                            className="pr-1 mb-2"
                            style={{ cursor: 'pointer' }}
                        >
                            <img className="mr-2" src="/img/activo.png" alt="" />
                            <Link
                                to={`/polizas/detalle/${objPoliza.idPoliza}`}
                                target="_blank"
                                className="stretched-link text-info position-relative"
                            >
                                #{objPoliza.idPoliza}
                            </Link>
                            <span className="fs--2"> | {objPoliza.vNombrePoliza}</span>
                            <span className="fs--2"> | {formatDate(objPoliza.dCreatedDate)}</span>
                        </Col>
                    );
                }

                // Si es una póliza básica sin asignar
                if (product.vCodigoBarras === "POL-BAS") {
                    return (
                        <Col
                            key={keyPoliza}
                            xs={12}
                            md={12}
                            className="pr-1 mb-2"
                            style={{ cursor: 'pointer' }}
                        >
                            <span className="ms-2 badge badge-soft-warning">NO HA SIDO RENOVADA</span>
                        </Col>
                    );
                }

                return null;
            })}
        </>
    );
};

PolizasAsignadas.propTypes = {
    objPolizas: PropTypes.array.isRequired,
    product: PropTypes.object.isRequired
};

export default PolizasAsignadas;
